import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';
import AuthDropdown from '../../AuthDropdown';

const ActionArea = ({
  isAuthenticated,
  user,
  login,
  signup,
  talkToSales
}) => {
  let authSection;

  if (isAuthenticated) {
    authSection = <AuthDropdown {...user.profile} />;
  } else {
    authSection = (
      <React.Fragment>
        <button className="login-link btn btn-transparent btn-sm" onClick={login}>Login</button>
        <button className="login-button btn btn-success btn-sm" onClick={signup}>Sign up</button>
      </React.Fragment>
    );
  }

  return (
    <div className={styles.actions}>
      <button className={`${styles.talkToSales} btn btn-transparent btn-sml`} onClick={talkToSales}>
        Talk to Sales
      </button>

      {authSection}
    </div>
  );
};

ActionArea.propTypes = {
  login: PropTypes.func.isRequired,
  signup: PropTypes.func.isRequired,
  talkToSales: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  user: PropTypes.object
};

export default ActionArea;
